import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

import { PillSelect } from '@/apps/latest/components/molecules/PillSelect'

import {
  useAddNutritionStaff,
  useNutritionStaff,
  useSetNutritionRecordStaff,
} from './useNutritionStaff'

interface Props {
  // 今回の記録。カルテで今回がまだ始まっていなければ無く、その PC の担当 (次に作る記録の担当) を替える
  eventId?: string
  // 記録の担当 (共有の event の pharmacist_id)。担当の無い記録は null。記録が無いときは見ない
  value?: string | null
}

// 名前の行の右の並びの左端の「担当」の pill (design-book ADR-0078)。選んだ人が記録の担当 = 署名の管理栄養士。
// 録る前から完了の後まで、どの段でも同じ場所で替えられる。選択肢は店の名簿で、menu の末尾でその場で足す
// (直す・外すは名簿の画面)。薬剤師の PharmacistMenu と違い 1 人以下でも出す (最初の 1 人を足す口を兼ねる)。
// 選んだ・足した人は、その PC の次の記録の担当にもなる (記録を作るときに渡す)。
export const NutritionStaffMenu = ({ eventId, value }: Props) => {
  const { staff, sessionStaffId, setSessionStaffId } = useNutritionStaff()
  const setStaff = useSetNutritionRecordStaff(eventId ?? '')
  const addStaff = useAddNutritionStaff()

  const choose = (id: string) => {
    setSessionStaffId(id)
    if (eventId) setStaff.mutate(id)
  }

  return (
    <PillSelect
      value={(eventId ? value : sessionStaffId) ?? ''}
      options={staff.map((p) => ({ value: p.id, label: p.display_name }))}
      onChange={choose}
      ariaLabel="担当"
      icon={<PersonOutlineIcon />}
      disabled={setStaff.isPending}
      emptyLabel={staff.length === 0 ? '担当を追加' : '担当を選ぶ'}
      addRow={{
        label: '担当者を追加',
        placeholder: '名前',
        onAdd: async (name) => choose(await addStaff(name)),
      }}
    />
  )
}
